// Versione "lite" (palette awrabet/koba) dei template sports usati dalla home di gojjobet
// dal filtro in giù. Stessa struttura di jamibet/mobile-templates/sports.jsx, colori gojjo-lite.
import {h, Fragment} from "preact";

import * as I from "../../jamibet/utils/icons.jsx";

export function HeaderContainer({children}) {
	return <div class="relative flex h-11 w-full items-stretch border-t border-b border-t-gojjo-lite-300 border-b-gojjo-lite-300 bg-gojjo-lite-100 text-gojjo-lite-950">
		{children}
	</div>
}
export function TimeFilterHolder({children, ...props}) {
	return <div class="fn-timefilter flex h-full shrink grow justify-stretch text-xs" {...props}>
		{children}
	</div>
}
export function TimeFilterBtn({children, active, ...props}) {
	if (!active) {
		return <div class="flex h-full w-8 shrink grow items-center justify-center border-b-2 border-r border-gojjo-lite-300 border-b-transparent" {...props}>
			{children}
		</div>
	}
	return <div class="flex h-full w-8 shrink grow items-center justify-center border-b-2 border-r border-gojjo-lite-300 border-b-gojjo-gold-lite-500" {...props}>
		{children}
	</div>
}
export function SearchBar({onClick, onInput, open, children, value, ref}) {
	return <div class="w-11" onClick={onClick} ref={ref}>
		<div
			tabIndex={0}
			class={
				"absolute right-0 top-0 flex h-full bg-gojjo-lite-100 text-gojjo-lite-950 transition-all focus-within:w-full hover:w-full "
				+(open ? 'w-full' : 'w-11')
			}
		>
			<input type="text" class="mr-11 w-full min-w-0 bg-transparent px-2 text-gojjo-lite-950" placeholder="Search" onInput={onInput} value={value} />
			<div class="absolute bottom-0 right-0 top-0 flex w-11 items-center justify-center">
				<div class="h-4 w-4">
					<I.SearchIcon class="fill-current h-full" />
				</div>
			</div>
			{open && children}
		</div>
	</div>
}

export function SearchContentWrapper({children, ref}) {
	return <div class="absolute h-30 left-0 right-0 top-full overflow-hidden z-50" ref={ref}>
		{children}
	</div>
}

export function SearchPopupContainer({children}) {
	return <div class="bg-gojjo-lite-100 border border-gojjo-gold-lite-500 w-full text-gojjo-lite-950">{children}</div>
}
export function SearchPopupHeader({children}) {
	return <div class="h-8 bg-gojjo-lite-200 border-b border-gojjo-lite-300 flex justify-between items-center text-sm">{children}</div>
}
export function SearchPopupLabel({children}) {
	return <div class="px-2">{children}</div>
}
export function SearchPopupClose({children, onClick}) {
	return <div class="px-2" onClick={onClick}>{children}</div>
}
export function SearchPopupEventsHolder({children}) {
	return <div class="h-52 overflow-y-auto">{children}</div>
}
export function SearchEventRow({children, onClick}) {
	return <div class="h-14 bg-gojjo-lite-100 border-b border-gojjo-lite-300 text-gojjo-lite-950 py-2 flex justify-between flex-col" onClick={onClick}>{children}</div>
}
export function SearchEventName({children}) {
	return <div class="search-event-name px-2 text-sm pb-1 truncate">{children}</div>
}
export function SearchEventInfoRow({children}) {
	return <div class="flex items-center px-2 text-xs gap-1">{children}</div>
}
export function SearchEventFlag({children}) {
	return <div class="w-4 flex relative top-px">{children}</div>
}
export function SearchEventTournamentName({children}) {
	return <div class="tournament truncate">{children}</div>
}
export function SearchEventSeparator({children}) {
	return <div class="grow">{children}</div>
}
export function SearchEventSportFlag({children}) {
	return <div>{children}</div>
}

export function SportsHolder({children, ...props}) {
	return <div class="scrollbar-hide h-16 w-full items-stretch overflow-x-auto overflow-y-hidden border-t border-b border-gojjo-lite-300 bg-gojjo-lite-200 text-gojjo-lite-950">
		<div class="flex h-full min-w-full">
			{children}
		</div>
	</div>
}
export function SportButton({sport, active, ...props}) {
	return <SportLikeButton active={active} {...props}>
		<SportIconBox>
			<SportIcon sport={sport} />
			<span class="block absolute -top-1.5 -right-2 text-xs">{sport.count}</span>
		</SportIconBox>
		<SportName>{sport.name}</SportName>
    </SportLikeButton>
}
export function SportLikeButton({sport, active, children, ...props}) {
	return <div class={"flex h-full w-16 shrink-0 grow-0 flex-col items-center justify-start pt-1.5 border-b-2 "+(active ? 'border-b-gojjo-gold-lite-500' : 'border-b-transparent')} {...props}>
		{children}
    </div>
}
export function SportIconBox({children}) {
	return <div class="relative flex justify-center items-center h-8 w-8">
		{children}
    </div>
}
export function SportIcon({sport}) {
	return <span class={"text-2xl sporticon sp_"+(sport.id && sport.id.split('/')[2])}></span>
}
export function SportIconSmall({sport}) {
	return <span class={"text-sm sporticon sp_"+(sport.id && sport.id.split('/')[2])}></span>
}
export function SportName({children}) {
	return <span class="text-xs truncate max-w-full">{children}</span>
}

export function TournamentIcon({tournament, ...props}) {
	return <span class={"h-4 w-4 inline-block bg-no-repeat bg-center bg-contain "+(props['class']||'')}></span>
}
